import "emun.customer/customer-dashboard.scss";
import templateUrl from "emun.customer/customer-dashboard.htm";
import controller from "emun.customer/customer-dashboard.controller";

export default {
  bindings: {
    customerId: "@",
    autoEdit: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
